import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";

import { useEffect } from "react";

import "./App.css";

import Login from "./pages/Login";
import Home from "./pages/Home";
import SwipeCard from "./pages/SwipeCard";
import PointsActionPage from "./pages/PointsActionPage";
import CheckBalancePage from "./pages/CheckBalancePage";
import TransactionHistoryPage from "./pages/TransactionHistoryPage";
import FindCustomerPage from "./pages/FindCustomerPage";
import AddPointsPage from "./pages/AddPointsPage";
import ScanCustomerPage from "./pages/ScanCustomerPage";
import RedeemPointsPage from "./pages/RedeemPointsPage";

function ProtectedRoute({ children }) {
  const storeId = localStorage.getItem("storeId");

  if (!storeId) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function NavigationBlocker() {
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = () => {
      const storeId = localStorage.getItem("storeId");

      if (storeId) {
        navigate("/Home", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener(
        "popstate",
        handlePopState
      );
    };
  }, [navigate]);

  return null;
}

function App() {
  return (
    <Router>
      <NavigationBlocker />

      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/Home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/SwipeCard"
          element={
            <ProtectedRoute>
              <SwipeCard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pages/swipe"
          element={
            <ProtectedRoute>
              <SwipeCard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/PointsActionPage"
          element={
            <ProtectedRoute>
              <PointsActionPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CheckBalancePage"
          element={
            <ProtectedRoute>
              <CheckBalancePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/TransactionHistoryPage"
          element={
            <ProtectedRoute>
              <TransactionHistoryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pages/transaction-history"
          element={
            <ProtectedRoute>
              <TransactionHistoryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pages/find-customer"
          element={
            <ProtectedRoute>
              <FindCustomerPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pages/add-points/:memberId"
          element={
            <ProtectedRoute>
              <AddPointsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pages/scan-customer"
          element={
            <ProtectedRoute>
              <ScanCustomerPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pages/redeem-points/:memberId"
          element={
            <ProtectedRoute>
              <RedeemPointsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={<Navigate to="/Home" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;